class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
(function () {
  function formatAUD(amount) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function updateGiftProgress(cart) {
    const el = document.querySelector('.ll-gift-progress');
    if (!el) return;

 const threshold = parseFloat(el.dataset.giftThreshold || '140');
    const subtotal = (cart && typeof cart.total_price === 'number')
      ? cart.total_price / 100
      : 0;

    const remaining = Math.max(0, threshold - subtotal);
    const percent = Math.min(100, Math.round((subtotal / threshold) * 100));

    const remainingEl = el.querySelector('.ll-gift-remaining');
    const fillEl = el.querySelector('.ll-gift-progress__bar-fill');
    const subtextEl = el.querySelector('.ll-gift-progress__subtext');
    const barEl = el.querySelector('.ll-gift-progress__bar');

    if (remainingEl) remainingEl.textContent = formatAUD(remaining);
    if (fillEl) fillEl.style.width = percent + '%';
    if (barEl) barEl.setAttribute('aria-valuenow', String(percent));

    if (subtotal > 0 && remaining > 0) {
      el.hidden = false;
      if (subtextEl) subtextEl.hidden = true;
    }

    if (subtotal >= threshold) {
      el.hidden = false;
      if (subtextEl) subtextEl.hidden = false;
    }

    if (subtotal <= 0) {
      el.hidden = true;
    }
  }

  async function fetchCartAndUpdate() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      updateGiftProgress(cart);
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);

  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('cart:refresh', fetchCartAndUpdate);
})();

// >>>>>>>>>>>>> This is a duplication of code above.
(function () {
  function formatAUD(amount) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function updateGiftProgress(cart) {
    // IMPORTANT: only target the drawer content (not header or elsewhere)
    const root = document.querySelector('#mini-cart');
    if (!root) return;

    const el = root.querySelector('.ll-gift-progress');
    if (!el) return;

    const threshold = parseFloat(el.dataset.giftThreshold || '140');
    const subtotal = (cart && typeof cart.total_price === 'number') ? cart.total_price / 100 : 0;

    const remaining = Math.max(0, threshold - subtotal);
    const percent = threshold > 0 ? Math.min(100, Math.round((subtotal / threshold) * 100)) : 0;

    const remainingEl = el.querySelector('.ll-gift-remaining');
    const fillEl = el.querySelector('.ll-gift-progress__bar-fill');
    const subtextEl = el.querySelector('.ll-gift-progress__subtext');
    const barEl = el.querySelector('.ll-gift-progress__bar');

    if (remainingEl) {
  if (subtotal >= threshold) {
    remainingEl.closest('p').hidden = true;
  } else {
    remainingEl.closest('p').hidden = false;
    remainingEl.textContent = formatAUD(remaining);
  }
}
    if (fillEl) fillEl.style.width = percent + '%';
    if (barEl) barEl.setAttribute('aria-valuenow', String(percent));

    if (subtotal <= 0) {
      el.hidden = true;
      return;
    }

    // show it when cart has items
    el.hidden = false;

 // unlocked state
if (subtotal >= 95) {
  if (subtextEl) {
    subtextEl.hidden = false;
    subtextEl.innerHTML = `<strong>You've unlocked an Exlusive Offer — now in your cart! </strong>`;
  }
} else {
  if (subtextEl) subtextEl.hidden = true;
}

  }

  async function fetchCartAndUpdate() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      updateGiftProgress(cart);
    } catch (e) {
      // fail silently
    }
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);

  // Your theme emits this when the drawer opens (I saw it in your file earlier)
  document.addEventListener('cartdrawer:opened', fetchCartAndUpdate);

  // These are common in Dawn-like updates
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('cart:refresh', fetchCartAndUpdate);
})();